import PropTypes from "prop-types";
import classNames from "classnames";
import styles from "./DiamondMultipleChoiceResultItem.module.css";
import GreenCheckmark from "ManagementTeam/Shared/GreenCheckmark";
import ProxyVoteIcon from "ManagementTeam/Shared/ProxyVoteIcon";
import ProxyCheckmark from "ManagementTeam/DashboardPage/ProxyCheckmark";

/**
 * View component. Shows information about the diamond and their voting status
 */

//voting status: yes, no, pending

export function DiamondMultipleChoiceResultItem({ diamondInfo, isHideInfo }) {
  return (
    <div className={styles.container}>
      {diamondInfo.checkedIn || diamondInfo.proxyCheckedIn ? (
        <div className={styles.checkmarkContainer}>
          {diamondInfo.checkedIn && !diamondInfo.proxyCheckedIn && (
            <GreenCheckmark className={styles.checkmark} />
          )}
          {diamondInfo.proxyCheckedIn && (
            <div className={styles.checkMark}>
              <ProxyCheckmark />
            </div>
          )}
          <div className={styles.checkmarkBackground}></div>
        </div>
      ) : null}

      <img
        src={diamondInfo.photo}
        alt={diamondInfo.firstName}
        className={styles.image}
      />
      <div>
        {diamondInfo.firstName} {diamondInfo.lastName}
      </div>
      {!isHideInfo && (
        <div
          className={classNames(
            diamondInfo.isProxyVote === true
              ? styles.resultsContainerProxy
              : styles.resultsContainerNoProxy
          )}
        >
          <div
            className={classNames(
              diamondInfo.isProxyVote === true
                ? styles.selectionsWithProxy
                : styles.selections
            )}
          >
            {diamondInfo.selections.map((selection) => {
              return <div>{selection}</div>;
            })}
          </div>
          <div
            className={classNames(
              diamondInfo.isProxyVote === true ? styles.proxyVote : null
            )}
          >
            {diamondInfo.isProxyVote === true ? <ProxyVoteIcon /> : null}
          </div>
        </div>
      )}
    </div>
  );
}

DiamondMultipleChoiceResultItem.propTypes = {
  diamondInfo: PropTypes.object,
};
